module.exports = __webpack_public_path__ + "static/images/l-mask.906ca20.png";